export default __webpack_public_path__ + "static/media/contacto_tarjeta.4c48026c.svg";